import { useTranslation } from 'react-i18next';
import { useGetCatalogQuery } from '@platform/state/api';
import type { IOrderedTypeSummary } from './analytics/ba/IOrderedTypeSummary';
import type { IModuleTablesListProps } from './IModuleTablesListProps';
import { ModuleEntityRow } from './ModuleEntityRow';
import { ModuleTableRow } from './ModuleTableRow';
import { overviewTablesOf } from './overviewTablesOf';
import { useOverviewEntityRows } from './useOverviewEntityRows';

/**
 * «Таблиці модуля» на огляді (прототип v4 moTables / moEnts): компактна картка зі шапкою великими літерами — реалізовані таблиці
 * (головна, далі дочірні в порядку модулів простору — overviewTablesOf) з «відкрито N» і кількістю, далі спроєктовані сутності
 * MOD_ENTITIES прототипу (перші шість, useOverviewEntityRows) приглушеними рядками з описом.
 */
export function ModuleTablesList({ ws, module }: IModuleTablesListProps) {
  const { t } = useTranslation();
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws }, { skip: !ws });
  const types = catalog?.modules.find((m) => m.key === module.module.key)?.recordTypes as IOrderedTypeSummary[] | undefined;
  const tables = overviewTablesOf(module, (key) => types?.find((r) => r.key === key)?.order);
  const entities = useOverviewEntityRows(module);
  return (
    <section className="mp-card">
      <div className="mp-card__head">{t('overview.tables')}</div>
      {tables.map((rt) => <ModuleTableRow key={rt.key} ws={ws} moduleKey={module.module.key} rt={rt} />)}
      {entities.map((row) => <ModuleEntityRow key={row.key} row={row} />)}
    </section>
  );
}
